import ToggleConfig from '../../../config/ToggleConfig';
import { ILocality } from '../../../locality/Locality';

export default function filterLocality(
  locality: ILocality | undefined,
  toggle: ToggleConfig
): ILocality | undefined {
  if (!locality) {
    return locality;
  }
  const copy = { ...locality };
  if (!toggle.internalIp) {
    delete copy.internalIP;
    delete copy.iceCandidates;
  }
  if (!toggle.machineName) {
    delete copy.machineName;
  }

  return copy;
}
